import React from "react";

import { Button, Card, Col, Row, Tab, Tabs } from "react-bootstrap";

import FacilityFilesTab from "./FacilityFilesTab";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

const FacilityFiles = () => {
  const { facilityId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "files";

  return (
    <Row>
      <Col xs={12} sm={12} md={12} lg={12} className="mb-3">
        <div className="d-flex flex-row mb-3 align-items-center">
          <div className="flex-grow-1">
            <h4 className="mb-0">File Library</h4>
          </div>
          <div>
            <Button
              size="sm"
              as={Link}
              to={`/facilities/${facilityId}`}
              className="me-2"
              variant="outline-primary"
            >
              <span
                translate="no"
                className="material-symbols-outlined md-16 me-1"
              >
                arrow_back
              </span>
              Entity Overview
            </Button>
          </div>
        </div>
        <Card>
          <Tabs
            activeKey={tab}
            onSelect={(k) => navigate(`?tab=${k}`)}
            variant="tabs"
            className="m-3"
          >
            <Tab eventKey={"files"} title="Files & Photos" className="px-2">
              <FacilityFilesTab />
            </Tab>
          </Tabs>
        </Card>
      </Col>
    </Row>
  );
};

export default FacilityFiles;
